/**
 * schema コマンド
 */

import type { ArgumentsCamelCase, Argv } from 'yargs'
import type { HelpOption, HelpPositional } from '../lib/help-schema.js'
import modelSchemas from '../schemas/model-schemas.json'

export function command(): string { return 'schema <subcommand>' }
export function describe(): string { return 'ワークフローモデルの JSON Schema バリデーション定義を表示する。' }

export const helpPositionals: HelpPositional[] = [
  { name: 'subcommand', type: 'string', required: true, description: 'show' },
]

export const helpOptions: HelpOption[] = [
  { name: 'type', type: 'string', description: 'definition | dataSchema | dataAccessPolicy（省略時は全スキーマを返す）' },
]

type SchemaType = 'definition' | 'dataSchema' | 'dataAccessPolicy'
const SCHEMA_TYPES: SchemaType[] = ['definition', 'dataSchema', 'dataAccessPolicy']

export function builder(yargs: Argv): Argv {
  return yargs
    .command(
      'show',
      '全スキーマを表示。--type definition|dataSchema|dataAccessPolicy で絞り込み可。',
      (y) => y.option('type', {
        type: 'string',
        description: '取得するスキーマの種類（省略時は全スキーマを返す）',
        choices: SCHEMA_TYPES,
      }),
      async (argv) => {
        const type = argv.type as SchemaType | undefined
        const result = type ? modelSchemas[type] : modelSchemas
        process.stdout.write(JSON.stringify(result, null, 2) + '\n')
      },
    )
    .demandCommand(1, '利用可能なサブコマンド: show')
}

export async function handler(_argv: ArgumentsCamelCase): Promise<void> {}
